/* eslint-disable max-lines */
/* eslint-disable no-underscore-dangle */
// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import isEqual from 'lodash/isEqual';
import { setClickAnalyticsData, trackClick } from '@tcp/core/src/analytics/actions';
import logger from '@tcp/core/src/utils/loggerInstance';
import { emailSubmit } from '@tcp/core/src/components/features/account/LoginPage/container/LoginPage.actions';
import { getContactFormValuesFromSS } from '@tcp/core/src/components/features/CnC/SinglePageCheckout/molecules/ContactForm/ContactForm.util';
import { SPC_SECTION } from '@tcp/core/src/components/features/CnC/SinglePageCheckout/container/SinglePageCheckout.constants';
import {
  getAfterPayMinOrderAmount,
  getAfterPayMaxOrderAmount,
  getExtendedPreOrderValue,
  getIsDefaultApplePayAbTest,
  getDefaultAfterPayAbTest,
  getcouponSectionNewDesign,
  getDynamicShippingCharge,
  getIsFreeShippingProgressBarDisabled,
  getIsBossEnabled,
  getCheckoutMetricsStatus,
  freeShippingMessageForPromos,
  getIsAdyenPaymentEnabled,
  getIsPayPalDisabled,
  getIsPayPalDisabledForPickupOrders,
  getIsAdyenApplePayBagPageEnabled,
  getAdyenApplePayBagPageVisibility,
  getPayPalSingleStoreBopisEnabled,
} from '@tcp/core/src/reduxStore/selectors/session.selectors';
import { getCD66Data } from '@tcp/core/src/components/features/account/BuyItAgain/container/BuyItAgain.selectors';
import { getCD81Data } from '@tcp/core/src/components/features/account/BirthdayModule/container/BirthdayModule.selectors';
import { updateStoreItem as updateItem } from '@tcp/core/src/components/features/CnC/CartItemTile/container/CartItemTile.actions';
import * as PickupSelectors from '@tcp/core/src/components/common/organisms/ProductPickup/container/ProductPickup.selectors';
import {
  getFirstTimeCaptureBanner,
  getFirstTimeCaptureShopMenu,
} from '@tcp/core/src/components/features/browse/SearchDetail/container/SearchDetail.selectors';
import {
  getBossGCAndPreOrderCase,
  getOrderProducts,
  getBossAndPreOrder,
  getBossAndGC,
  getBossInEligible,
  getSinglePageCheckoutSectionState,
  getPaymentId,
  checkIsPaymentSectionSaved,
  getIsAppleMobileWalletSetup,
} from '@tcp/core/src/components/features/CnC/SinglePageCheckout/container/SinglePageCheckout.selector';
import {
  setSessionStorage,
  getSessionStorage,
  isBagRoute,
  isClient,
  getViewportInfo,
  checkExtendedPreOrderItem,
  isAndroidWeb,
} from '@tcp/core/src/utils';
import { getAppleClientTokenData } from '@tcp/core/src/components/features/CnC/Checkout/container/CheckoutApple.selector.js';
import selectors from '@tcp/core/src/components/features/CnC/Checkout/container/Checkout.selector';
import { OpenBirthdayRecommandationDrawer } from '@tcp/core/src/components/features/account/BirthdayProductListing/container/BirthdayProductListing.actions';
import { resetValueOfBirthdayModule } from '@tcp/core/src/components/common/organisms/QuickViewModal/container/QuickViewModal.actions';
import BagPageSelectors, {
  isMixedOrderStatus,
  getECOMStatus,
  getIsPlccCheckoutEnabled,
  getOrderType,
  getConfirmationModalFlag,
  isECOMStatus,
  getIsFreeShippingCouponApplied,
  getFreeShippingThresholdValue,
  getFreeShippingType,
  isMixedPaymentWithPaypal,
  isPickuOrderStatus,
  getIsMultistoreOrder,
} from '../../BagPage/container/BagPage.selectors';
import AddedToBagActionsView from '../views/AddedToBagActions.view';
import { getGrandTotal } from '../../AddedToBag/container/AddedToBag.selectors';
import { CHECKOUT_ROUTES } from '../../Checkout/Checkout.constants';
import utility from '../../Checkout/util/utility';
import bagPageActions from '../../BagPage/container/BagPage.actions';
import {
  getIsInternationalShipping,
  getIsPayPalEnabled,
  getOptimisticAddBagModal,
  getIsStickyPaymentAbTestEnabled,
} from '../../../../../reduxStore/selectors/session.selectors';
import {
  getAppliedExpiredCouponListState,
  verifyExpiredCoupons,
} from '../../common/organism/CouponAndPromos/container/Coupon.selectors';
import checkoutSelectors, {
  isUsSite,
  getIsApplePayEnabled,
  getLoginV2FlowEnabled,
} from '../../Checkout/container/Checkout.selector';
import CHECKOUT_ACTIONS, {
  setVenmoPaymentInProgress,
  setApplePaymentInProgress,
} from '../../Checkout/container/Checkout.action';

import {
  getCartOrderId,
  getPageName,
  getCartLoadingState,
  getCartOrderList,
  getCheckoutProgress,
  getIsBackPackAloneError,
  getIsBackPackOOS,
  getOrderShipments,
} from '../../CartItemTile/container/CartItemTile.selectors';
import { toastMessageInfo } from '../../../../common/atoms/Toast/container/Toast.actions';
import { getLoaderStatus } from '../../../../common/molecules/Loader/container/Loader.selector';
import GiftCardsSelectors from '../../Checkout/organisms/GiftCardsSection/container/GiftCards.selectors';
import { getCreditCardDefault } from '../../../account/Payment/container/Payment.selectors';
import { openShopAllDrawer } from '../../BuyItAgainBagPage/container/BuyItAgainBagPage.actions';
import LoginPageDynamicStore from '../../../account/LoginPage/container/LoginPageDynamicStore';
import { getIsFromBirthdayModule } from '../../../../common/organisms/QuickViewModal/container/QuickViewModal.selectors';
import BuyItAgainDynamicStore from '../../../account/BuyItAgain/container/BuyItAgainDynamicStore';
import { getLabelFromCopyOrFromTranslation } from '../../../../../utils/labels/labelUtilty';
import {
  CHECKOUT_REVIEW_LABELS,
  labelAfterPaySubmit,
  labelAfterPayThresholdError,
} from './AddedToBagActions.labels';
import { getProductTotal } from '../../common/organism/OrderLedger/container/orderLedger.selector';
import { getCurrency } from '../../../../common/molecules/PriceCurrency/container/PriceCurrency.selectors';
import { setCheckoutMetricsStatus } from '../../../../../reduxStore/actions';

export class AddedToBagContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isCheckoutBannerHidden: false,
      containsExtendedOrder: false,
    };
    this.handleCheckoutHidden = this.handleCheckoutHidden.bind(this);
    this.rootElemId = '__next';
  }

  componentDidMount() {
    const { cartOrderItems, extendedOrderThreshold } = this.props;
    this.handleExtendedPreOrderItem(cartOrderItems, extendedOrderThreshold);
    if (isAndroidWeb() && this.rootElemId) {
      document.querySelector(`#${this.rootElemId}`).style.display = '';
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    return !(isEqual(nextState, this.state) && isEqual(nextProps, this.props));
  }

  componentDidUpdate(prevProps) {
    const { cartOrderItems, extendedOrderThreshold } = this.props;
    if (prevProps.cartOrderItems && cartOrderItems) {
      const prevPropsLength = JSON.parse(JSON.stringify(prevProps.cartOrderItems)).length;
      const cuurentPropsLength = JSON.parse(JSON.stringify(cartOrderItems)).length;
      if (!isEqual(prevPropsLength, cuurentPropsLength) || !this.state.containsExtendedOrder) {
        this.handleExtendedPreOrderItem(cartOrderItems, extendedOrderThreshold);
      }
    }
  }

  handleCheckoutHidden = (value) => {
    if (value) {
      this.setState({ isCheckoutBannerHidden: true });
    } else {
      this.setState({ isCheckoutBannerHidden: false });
    }
  };

  onClickViewBagFunc = async () => {
    const { closeBirthdayRecommandationDrawer } = this.props;
    closeBirthdayRecommandationDrawer(false);
    if (isBagRoute()) {
      const { onRequestClose, openBIAShopAllDrawer } = this.props;
      onRequestClose();
      await BuyItAgainDynamicStore();
      openBIAShopAllDrawer(false);
    }
    if (isAndroidWeb() && this.rootElemId) {
      document.querySelector(`#${this.rootElemId}`).style.display = '';
    }
    utility.routeToPage(CHECKOUT_ROUTES.bagPage);
  };

  onClickViewBag = () => {
    setTimeout(() => {
      this.onClickViewBagFunc();
    }, 0);
  };

  /**
   * @description - onCartCheckout method will check for selected checkout method
   * @param {object} payload - checkout payload for app and web
   */
  onCartCheckout = async (payload) => {
    const {
      handleCartCheckout,
      setVenmoInProgress,
      toastMessage,
      onEmailSubmit,
      emailAddressFromSS,
      isLoginV2FlowEnabled,
    } = this.props;
    if (payload && !payload.isVenmoProgress) {
      setVenmoInProgress(false);
    }
    if (payload && payload.venmoErrorMessage) {
      toastMessage(payload.venmoErrorMessage);
    } else {
      handleCartCheckout(payload);
    }
    if (emailAddressFromSS && isLoginV2FlowEnabled) {
      const { emailAddress, isExistingUser } = emailAddressFromSS;
      if (emailAddress && isExistingUser === undefined) {
        await LoginPageDynamicStore();
        onEmailSubmit({ emailAddress });
      }
    }
  };

  isMobileDimension = () => {
    if (window) {
      const { innerWidth: width } = window;
      if (width < 450) {
        return true;
      }
      return false;
    }
    return false;
  };

  handleExtendedPreOrderItem(cartOrderItems, extendedOrderThreshold) {
    const allOrderItems = cartOrderItems && JSON.parse(JSON.stringify(cartOrderItems));
    const containsExtendedOrder = allOrderItems
      ? checkExtendedPreOrderItem(allOrderItems, extendedOrderThreshold)
      : false;
    this.setState({ containsExtendedOrder });
  }

  render() {
    const {
      showAddTobag,
      isEditingItem,
      isInternationalShipping,
      isVenmoEnabled,
      isApplePayVisible,
      isECOM,
      navigation,
      showVenmo,
      isNoNEmptyBag,
      fromAddedToBagModal,
      inheritedStyles,
      isBagPageStickyHeader,
      closeModal,
      isUSSite,
      getPayPalSettings,
      containerId,
      hideHeader,
      checkoutServerError,
      isPayPalWebViewEnable,
      venmoError,
      orderId,
      isPayPalHidden,
      payPalTop,
      paypalButtonHeight,
      isAddedToBag,
      isBagPage,
      isMiniBag,
      setClickAnalyticsDataCheckout,
      cartOrderItems,
      clearCheckoutServerError,
      isPayPalEnabled,
      setIsPaypalBtnHidden,
      bagLoading,
      resetTimerStatus,
      isVenmoAppInstalled,
      showCondensedHeader,
      isPayPalEnabledKillSwitch,
      appliedExpiredCoupon,
      pageName,
      applePayAppData,
      cartValue,
      enableKeepShoppingCTA,
      handleContinueShopping,
      orderBalanceTotal,
      addedFromSBP,
      showSpcCheckout,
      spcBag,
      isCartLoading,
      isNewRedesignedModal,
      addToBagModalError,
      afterPayInProgress,
      afterPayMinOrderAmount,
      afterPayMaxOrderAmount,
      trackClickAfterPay,
      setAnalyticsTriggered,
      newBag,
      isOptmisticAddToBagModal,
      newMiniBag,
      isScrolling,
      userDefaultStore,
      updateStoreItem,
      updateStoreCompleted,
      cartItems,
      bossGCAndPreOrderCase,
      isStickyCheckoutButtonEnabled,
      isStickyCheckoutPaymentDisabled,
      loaderStatus,
      isPayPalButtonRenderDone,
      isAddedToBagRedesign,
      productItems,
      checkOutInProgress,
      isMixedOrder,
      bossAndGC,
      bossAndPreOrder,
      isBackPackAloneError,
      isBackPackOOS,
      firstTouchValue,
      bossInEligible,
      firstTouchShopMenu,
      verifyAllExpiredCoupons,
      cd66Data,
      cd81Data,
      route,
      isPLCCInstantCheckout,
      orderType,
      appliedGiftCards,
      isExtendedPreorder,
      pageCategory,
      isFromStoreModal,
      isDefaultApplePayAbTest,
      isPaymentSectionSaved,
      applePayEnabledWithCard,
      defaultPayment,
      paymentId,
      isDefaultAfterPayTestEnabled,
      isAppWalletSetup,
      authorizationKey,
      isExpressAfterpayEnabled,
      startExpressCheckoutHandler,
      modalInfo,
      getEstimatedTaxAction,
      calculatedEstimatedTax,
      cartHaveGCItem,
      isFromBirthdayModule,
      closeBirthdayRecommandationDrawer,
      resetBirthdayModuleValue,
      router,
      fromPage,
      getIsUpdateShippingCalled,
      setIsUpdateShippingCalled,
      couponSectionNewDesign,
      shipments,
      freeShippingThreshold,
      productTotal,
      dynamicShippingCharge,
      isBossEnabled,
      shippingMethodSelected,
      isFreeShippingProgressBarDisabled,
      isShippingOrder,
      isFreeShippingCouponApplied,
      totalCount,
      totalAmount,
      isShowBagSimplifiedHeader,
      currency,
      currencySymbol,
      checkoutStartStatus,
      setCheckoutStartStatus,
      freeShippingMessageForPromosEnabled,
      freeShippingPromoType,
      isAdyenPaymentEnabled,
      isPayPalDisabled,
      isMixedPaymentWithPaypalValue,
      setIsPaypalClicked,
      isAdyenApplePayBagPageEnabled,
      isAdyenApplePayBagPageVisibilityEnabled,
      isPayPalSingleStoreBopisEnabled,
    } = this.props;
    const isMobile = isClient() ? getViewportInfo().isMobile : null;
    const hasAppliedGiftCards = appliedGiftCards?.size > 0;
    const { isCheckoutBannerHidden, containsExtendedOrder } = this.state;
    const isBopisBasket = orderType === 'PURE_BOPIS' && !isPayPalSingleStoreBopisEnabled;
    const hidePayPal =
      ((hasAppliedGiftCards ||
        isMixedOrder ||
        isMixedPaymentWithPaypalValue ||
        isBopisBasket ||
        parseFloat(cartValue) < 0.5) &&
        isAdyenPaymentEnabled) ||
      isPayPalDisabled;
    const isOrderTypeVisible =
      isAdyenApplePayBagPageVisibilityEnabled &&
      orderType &&
      isAdyenApplePayBagPageVisibilityEnabled.includes(orderType);
    const appleApyVisible = isAdyenApplePayBagPageEnabled
      ? isApplePayVisible && isOrderTypeVisible && !hasAppliedGiftCards
      : isApplePayVisible;

    return (
      <AddedToBagActionsView
        onClickViewBag={this.onClickViewBag}
        showAddTobag={showAddTobag}
        handleCartCheckout={this.onCartCheckout}
        isEditingItem={isEditingItem}
        isInternationalShipping={isInternationalShipping}
        isVenmoEnabled={isVenmoEnabled}
        isApplePayVisible={appleApyVisible}
        isECOM={isECOM}
        navigation={navigation}
        showVenmo={showVenmo}
        isNoNEmptyBag={isNoNEmptyBag}
        fromAddedToBagModal={fromAddedToBagModal}
        isBagPageStickyHeader={isBagPageStickyHeader}
        closeModal={closeModal}
        isUSSite={isUSSite}
        inheritedStyles={inheritedStyles}
        getPayPalSettings={getPayPalSettings}
        containerId={containerId}
        hideHeader={hideHeader}
        checkoutServerError={checkoutServerError}
        isPayPalWebViewEnable={isPayPalWebViewEnable}
        venmoError={venmoError}
        orderId={orderId}
        isPayPalHidden={isPayPalHidden}
        payPalTop={payPalTop}
        paypalButtonHeight={paypalButtonHeight}
        isAddedToBag={isAddedToBag}
        isBagPage={isBagPage}
        isMiniBag={isMiniBag}
        setClickAnalyticsDataCheckout={setClickAnalyticsDataCheckout}
        cartOrderItems={cartOrderItems}
        clearCheckoutServerError={clearCheckoutServerError}
        setIsPaypalBtnHidden={setIsPaypalBtnHidden}
        bagLoading={bagLoading}
        isPayPalEnabled={isPayPalEnabled}
        resetTimerStatus={resetTimerStatus}
        isVenmoAppInstalled={isVenmoAppInstalled}
        showCondensedHeader={showCondensedHeader}
        isPayPalEnabledKillSwitch={isPayPalEnabledKillSwitch}
        appliedExpiredCoupon={appliedExpiredCoupon}
        pageName={pageName}
        applePayAppData={applePayAppData}
        cartValue={cartValue}
        enableKeepShoppingCTA={enableKeepShoppingCTA}
        handleContinueShopping={handleContinueShopping}
        orderBalanceTotal={orderBalanceTotal}
        addedFromSBP={addedFromSBP}
        showSpcCheckout={showSpcCheckout}
        spcBag={spcBag}
        isCartLoading={isCartLoading}
        isNewRedesignedModal={isNewRedesignedModal}
        addToBagModalError={addToBagModalError}
        afterPayInProgress={afterPayInProgress}
        afterPayMinOrderAmount={afterPayMinOrderAmount}
        afterPayMaxOrderAmount={afterPayMaxOrderAmount}
        btnText={getLabelFromCopyOrFromTranslation(
          `${CHECKOUT_REVIEW_LABELS}.${labelAfterPaySubmit}`
        )}
        labelAfterPayThresholdError={getLabelFromCopyOrFromTranslation(
          `${CHECKOUT_REVIEW_LABELS}.${labelAfterPayThresholdError}`
        )}
        trackClickAfterPay={trackClickAfterPay}
        setAnalyticsTriggered={setAnalyticsTriggered}
        newBag={newBag}
        isOptmisticAddToBagModal={isOptmisticAddToBagModal}
        newMiniBag={newMiniBag}
        isScrolling={isScrolling}
        updateStoreItem={updateStoreItem}
        userDefaultStore={userDefaultStore}
        updateStoreCompleted={updateStoreCompleted}
        cartItems={cartItems}
        bossGCAndPreOrderCase={bossGCAndPreOrderCase}
        loaderStatus={loaderStatus}
        isPayPalButtonRenderDone={isPayPalButtonRenderDone}
        isMobile={isMobile}
        isAddedToBagRedesign={isAddedToBagRedesign}
        productItems={productItems}
        checkOutInProgress={checkOutInProgress}
        isMixedOrder={isMixedOrder}
        bossAndGC={bossAndGC}
        bossAndPreOrder={bossAndPreOrder}
        isBackPackAloneError={isBackPackAloneError}
        isPLCCInstantCheckout={isPLCCInstantCheckout && !hasAppliedGiftCards}
        isStickyCheckoutButtonEnabled={isStickyCheckoutButtonEnabled}
        handleCheckoutHidden={this.handleCheckoutHidden}
        isCheckoutBannerHidden={isCheckoutBannerHidden}
        isStickyCheckoutPaymentDisabled={isStickyCheckoutPaymentDisabled}
        isBackPackOOS={isBackPackOOS}
        firstTouchValueFromHP={firstTouchValue}
        firstTouchShopMenu={firstTouchShopMenu}
        bossInEligible={bossInEligible}
        verifyAllExpiredCoupons={verifyAllExpiredCoupons}
        cd66Data={cd66Data}
        cd81Data={cd81Data}
        route={route}
        orderType={orderType}
        containsExtendedOrder={containsExtendedOrder}
        isExtendedPreorder={isExtendedPreorder}
        pageCategory={pageCategory}
        isFromStoreModal={isFromStoreModal}
        isDefaultApplePayAbTest={isDefaultApplePayAbTest}
        isPaymentSectionSaved={isPaymentSectionSaved}
        applePayEnabledWithCard={applePayEnabledWithCard}
        defaultPayment={defaultPayment}
        paymentId={paymentId}
        isDefaultAfterPayTestEnabled={isDefaultAfterPayTestEnabled}
        isAppWalletSetup={isAppWalletSetup}
        authorizationKey={authorizationKey}
        isExpressAfterpayEnabled={isExpressAfterpayEnabled}
        startExpressCheckoutHandler={startExpressCheckoutHandler}
        modalInfo={modalInfo}
        getEstimatedTaxAction={getEstimatedTaxAction}
        calculatedEstimatedTax={calculatedEstimatedTax}
        cartHaveGCItem={cartHaveGCItem}
        isFromBirthdayModule={isFromBirthdayModule}
        closeBirthdayRecommandationDrawer={closeBirthdayRecommandationDrawer}
        resetBirthdayModuleValue={resetBirthdayModuleValue}
        router={router}
        fromPage={fromPage}
        getIsUpdateShippingCalled={getIsUpdateShippingCalled}
        setIsUpdateShippingCalled={setIsUpdateShippingCalled}
        couponSectionNewDesign={couponSectionNewDesign}
        shipments={shipments}
        freeShippingThreshold={freeShippingThreshold}
        productTotal={productTotal}
        dynamicShippingCharge={dynamicShippingCharge}
        isBossEnabled={isBossEnabled}
        shippingMethodSelected={shippingMethodSelected}
        isFreeShippingProgressBarDisabled={isFreeShippingProgressBarDisabled}
        isShippingOrder={isShippingOrder}
        isFreeShippingCouponApplied={isFreeShippingCouponApplied}
        totalCount={totalCount}
        totalAmount={totalAmount}
        isShowBagSimplifiedHeader={isShowBagSimplifiedHeader}
        currencySymbol={currencySymbol}
        currency={currency}
        checkoutStartStatus={checkoutStartStatus}
        setCheckoutStartStatus={setCheckoutStartStatus}
        freeShippingPromoType={freeShippingPromoType}
        freeShippingMessageForPromosEnabled={freeShippingMessageForPromosEnabled}
        isAdyenPaymentEnabled={isAdyenPaymentEnabled}
        isPayPalDisabled={hidePayPal}
        setIsPaypalClicked={setIsPaypalClicked}
        isAdyenApplePayBagPageEnabled={isAdyenApplePayBagPageEnabled}
        isAdyenApplePayBagPageVisibilityEnabled={isAdyenApplePayBagPageVisibilityEnabled}
      />
    );
  }
}

AddedToBagContainer.propTypes = {
  handleCartCheckout: PropTypes.func.isRequired,
  isInternationalShipping: PropTypes.bool.isRequired,
  isNoNEmptyBag: PropTypes.number.isRequired,
  isBagPageStickyHeader: PropTypes.bool,
  containerId: PropTypes.string,
  setClickAnalyticsDataCheckout: PropTypes.func.isRequired,
  cartOrderItems: PropTypes.shape([]).isRequired,
  bagLoading: PropTypes.bool.isRequired,
  showAddTobag: PropTypes.shape.isRequired,
  navigation: PropTypes.shape({}).isRequired,
  closeModal: PropTypes.func.isRequired,
  fromAddedToBagModal: PropTypes.bool.isRequired,
  payPalTop: PropTypes.number.isRequired,
  hideHeader: PropTypes.func.isRequired,
  isPayPalHidden: PropTypes.bool.isRequired,
  isPayPalEnabled: PropTypes.bool.isRequired,
  isPayPalEnabledKillSwitch: PropTypes.bool.isRequired,
  isEditingItem: PropTypes.bool.isRequired,
  isVenmoEnabled: PropTypes.bool.isRequired,
  clearCheckoutServerError: PropTypes.func.isRequired,
  setIsPaypalBtnHidden: PropTypes.func.isRequired,
  showCondensedHeader: PropTypes.func.isRequired,
  resetTimerStatus: PropTypes.func.isRequired,
  isPayPalWebViewEnable: PropTypes.bool.isRequired,
  getPayPalSettings: PropTypes.func.isRequired,
  orderId: PropTypes.string.isRequired,
  isVenmoAppInstalled: PropTypes.bool.isRequired,
  isUSSite: PropTypes.bool.isRequired,
  checkoutServerError: PropTypes.shape({}).isRequired,
  venmoError: PropTypes.string.isRequired,
  paypalButtonHeight: PropTypes.number.isRequired,
  isAddedToBag: PropTypes.bool.isRequired,
  isBagPage: PropTypes.bool.isRequired,
  isMiniBag: PropTypes.bool.isRequired,
  showVenmo: PropTypes.func.isRequired,
  setVenmoInProgress: PropTypes.func.isRequired,
  toastMessage: PropTypes.string.isRequired,
  inheritedStyles: PropTypes.shape({}).isRequired,
  onRequestClose: PropTypes.func.isRequired,
  appliedExpiredCoupon: PropTypes.shape({}),
  pageName: PropTypes.string.isRequired,
  cartValue: PropTypes.number,
  applePayAppData: PropTypes.shape({}),
  isApplePayVisible: PropTypes.bool.isRequired,
  enableKeepShoppingCTA: PropTypes.bool,
  handleContinueShopping: PropTypes.func,
  isECOM: PropTypes.bool,
  orderBalanceTotal: PropTypes.number.isRequired,
  addedFromSBP: PropTypes.bool,
  showSpcCheckout: PropTypes.bool,
  spcBag: PropTypes.bool,
  isCartLoading: PropTypes.bool.isRequired,
  isNewRedesignedModal: PropTypes.bool,
  addToBagModalError: PropTypes.string,
  afterPayMinOrderAmount: PropTypes.number,
  afterPayMaxOrderAmount: PropTypes.number,
  afterPayInProgress: PropTypes.bool,
  trackClickAfterPay: PropTypes.func,
  setAnalyticsTriggered: PropTypes.func,
  isOptmisticAddToBagModal: PropTypes.bool,
  isATBModalBackAbTestNewDesign: PropTypes.bool,
  newBag: PropTypes.func,
  newMiniBag: PropTypes.func,
  isScrolling: PropTypes.bool,
  userDefaultStore: PropTypes.shape({}).isRequired,
  firstItemInfo: PropTypes.shape({}).isRequired,
  updateStoreItem: PropTypes.func.isRequired,
  updateStoreCompleted: PropTypes.func.isRequired,
  cartItems: PropTypes.func.isRequired,
  bossGCAndPreOrderCase: PropTypes.bool.isRequired,
  bossAndPreOrder: PropTypes.bool.isRequired,
  bossAndGC: PropTypes.bool.isRequired,
  extendedOrderThreshold: PropTypes.number,
  router: PropTypes.shape({}),
  checkoutStartStatus: PropTypes.bool,
};

AddedToBagContainer.defaultProps = {
  appliedExpiredCoupon: [],
  isBagPageStickyHeader: false,
  containerId: null,
  cartValue: 0,
  applePayAppData: {},
  isECOM: false,
  enableKeepShoppingCTA: false,
  handleContinueShopping: () => {},
  addedFromSBP: false,
  showSpcCheckout: false,
  spcBag: false,
  isNewRedesignedModal: true,
  addToBagModalError: null,
  afterPayMinOrderAmount: 0,
  afterPayMaxOrderAmount: 1000,
  afterPayInProgress: false,
  trackClickAfterPay: () => {},
  setAnalyticsTriggered: () => {},
  isOptmisticAddToBagModal: false,
  isATBModalBackAbTestNewDesign: false,
  newBag: () => {},
  newMiniBag: () => {},
  extendedOrderThreshold: 0,
  router: {},
  checkoutStartStatus: 1,
};

const mapDispatchToProps = (dispatch) => {
  return {
    handleCartCheckout: (payload) => {
      dispatch(bagPageActions.startCheckout(payload));
    },
    setVenmoInProgress: (data) => {
      dispatch(setVenmoPaymentInProgress(data));
    },
    setAppleInProgress: (data) => dispatch(setApplePaymentInProgress(data)),
    setClickAnalyticsDataCheckout: (payload) => {
      try {
        let analyticSV = getSessionStorage('AnalyticsObj');
        analyticSV = typeof analyticSV === 'object' ? JSON.stringify(analyticSV) : analyticSV;
        const analyticsObj = (analyticSV && analyticSV.length && JSON.parse(analyticSV)) || {};
        const { checkoutClicked = false } = analyticsObj;
        if (!checkoutClicked)
          setSessionStorage({
            key: 'AnalyticsObj',
            value: JSON.stringify({ ...analyticsObj, checkoutClicked: true }),
          });
        dispatch(
          setClickAnalyticsData({
            ...payload,
            ...(!checkoutClicked && { metric86: payload.cartAmount, customEvents: ['event8'] }),
          })
        );
      } catch (e) {
        const analyticsObj = getSessionStorage('AnalyticsObj');
        logger.error('Error Occured in setClickAnalyticData', {
          error: e,
          extraData: {
            component: 'AddedtoBagActions.container',
            parsedObj: analyticsObj,
          },
        });
      }
    },
    clearCheckoutServerError: (data) => dispatch(CHECKOUT_ACTIONS.setServerErrorCheckout(data)),
    setIsPaypalBtnHidden: (payload) => {
      dispatch(bagPageActions.setIsPaypalBtnHidden(payload));
    },
    toastMessage: (payload) => {
      dispatch(toastMessageInfo(payload));
    },
    trackClickAfterPay: (eventData, payload) => {
      dispatch(setClickAnalyticsData(eventData));
      const timer = setTimeout(() => {
        dispatch(trackClick(payload));
        clearTimeout(timer);
      }, 250);
    },
    updateStoreItem: (payload, enableModal) => {
      dispatch(updateItem(payload, enableModal));
    },
    onEmailSubmit: (payload) => {
      dispatch(emailSubmit(payload));
    },
    closeBirthdayRecommandationDrawer: (action) => {
      dispatch(OpenBirthdayRecommandationDrawer(action));
    },
    openBIAShopAllDrawer: (payload) => dispatch(openShopAllDrawer(payload)),
    resetBirthdayModuleValue: (payload) => {
      dispatch(resetValueOfBirthdayModule(payload));
    },
    setCheckoutStartStatus: (payload) => {
      dispatch(setCheckoutMetricsStatus(payload));
    },
  };
};

const mapStateToProps = (state) => {
  const getOrderItems = getOrderProducts(state);
  const contactData = getSinglePageCheckoutSectionState()(state, SPC_SECTION.CONTACT);
  const afterPayAbTest = getDefaultAfterPayAbTest(state);
  const appleClientTokenData = getAppleClientTokenData(state);
  const { clientToken: authorizationKey } = appleClientTokenData || {};
  let isPayPalDisabled = getIsPayPalDisabled(state);
  const isPayPalDisabledForPickupOrders = getIsPayPalDisabledForPickupOrders(state);
  const isPickuOrder = isPickuOrderStatus(state);
  let isAdyenPaymentEnabled = getIsAdyenPaymentEnabled(state);
  const isMultiStoreOrder = getIsMultistoreOrder(state);
  if (
    isAdyenPaymentEnabled &&
    ((isPickuOrder && isPayPalDisabledForPickupOrders) || isMultiStoreOrder)
  ) {
    isAdyenPaymentEnabled = false;
    isPayPalDisabled = true;
  }
  return {
    isInternationalShipping: getIsInternationalShipping(state),
    isVenmoEnabled: checkoutSelectors.getIsVenmoEnabled(state),
    getPayPalSettings: checkoutSelectors.getPayPalSettings(state),
    isUSSite: isUsSite(state),
    checkoutServerError: checkoutSelectors.getCheckoutServerError(state),
    isPayPalWebViewEnable: BagPageSelectors.getPayPalWebViewStatus(state),
    orderId: getCartOrderId(state),
    venmoError: checkoutSelectors.getVenmoError(state),
    isPayPalHidden: BagPageSelectors.getIsPayPalHidden(state),
    cartOrderItems: BagPageSelectors.getOrderItems(state),
    bagLoading: BagPageSelectors.isBagLoading(state),
    isPayPalEnabled: BagPageSelectors.getIsPayPalEnabled(state),
    isVenmoAppInstalled: checkoutSelectors.isVenmoAppInstalled(state),
    isPayPalEnabledKillSwitch: getIsPayPalEnabled(state),
    appliedExpiredCoupon: getAppliedExpiredCouponListState(state),
    pageName: getPageName(state),
    applePayAppData: checkoutSelectors.getApplePayAppDataApp(state),
    cartValue: getGrandTotal(state),
    isECOM: getECOMStatus(state),
    isCartLoading: getCartLoadingState(state),
    afterPayInProgress: checkoutSelectors.getIsAfterPayInProgress(state),
    afterPayMinOrderAmount: getAfterPayMinOrderAmount(state),
    afterPayMaxOrderAmount: getAfterPayMaxOrderAmount(state),
    isOptmisticAddToBagModal: !!getOptimisticAddBagModal(state),
    isApplePayVisible: getIsApplePayEnabled(state),
    userDefaultStore: PickupSelectors.getUserDefaultPickupStore(state),
    cartItems: getCartOrderList(state),
    bossGCAndPreOrderCase: getBossGCAndPreOrderCase(state),
    bossAndPreOrder: getBossAndPreOrder(state),
    bossAndGC: getBossAndGC(state),
    bossInEligible: getBossInEligible(state),
    loaderStatus: getLoaderStatus(state),
    isPayPalButtonRenderDone: BagPageSelectors.isPayPalButtonRenderDone(state),
    isStickyCheckoutPaymentDisabled: getIsStickyPaymentAbTestEnabled(state),
    productItems: getOrderItems?._tail?.array || [],
    checkOutInProgress: getCheckoutProgress(state),
    isMixedOrder: isMixedOrderStatus(state),
    isBackPackAloneError: getIsBackPackAloneError(state),
    isBackPackOOS: getIsBackPackOOS(state),
    firstTouchValue: getFirstTimeCaptureBanner(state),
    firstTouchShopMenu: getFirstTimeCaptureShopMenu(state),
    emailAddressFromSS: getContactFormValuesFromSS(contactData),
    isLoginV2FlowEnabled: getLoginV2FlowEnabled(state),
    verifyAllExpiredCoupons: verifyExpiredCoupons(state),
    cd66Data: getCD66Data(state),
    cd81Data: getCD81Data(state),
    isPLCCInstantCheckout: getIsPlccCheckoutEnabled(state),
    orderType: getOrderType(state),
    appliedGiftCards: GiftCardsSelectors.getAppliedGiftCards(state),
    extendedOrderThreshold: getExtendedPreOrderValue(state),
    isDefaultApplePayAbTest: getIsDefaultApplePayAbTest(state),
    paymentId: getPaymentId(state),
    applePayEnabledWithCard: checkoutSelectors.getApplePayEnabledWithCard(state),
    defaultPayment: getCreditCardDefault(state),
    isPaymentSectionSaved: checkIsPaymentSectionSaved(state),
    isDefaultAfterPayTestEnabled: afterPayAbTest,
    isAppWalletSetup: getIsAppleMobileWalletSetup(state),
    authorizationKey,
    modalInfo: getConfirmationModalFlag(state),
    cartHaveGCItem: selectors.getIsCartHaveGiftCards(state),
    isFromBirthdayModule: getIsFromBirthdayModule(state),
    couponSectionNewDesign: getcouponSectionNewDesign(state),
    shipments: getOrderShipments(state),
    productTotal: getProductTotal(state),
    freeShippingThreshold: getFreeShippingThresholdValue(state),
    dynamicShippingCharge: getDynamicShippingCharge(state),
    shippingMethodSelected: checkoutSelectors.getSavedShippingMethod(state),
    isFreeShippingProgressBarDisabled: getIsFreeShippingProgressBarDisabled(state),
    isShippingOrder: isECOMStatus(state) || isMixedOrderStatus(state) || false,
    isBossEnabled: getIsBossEnabled(state),
    isFreeShippingCouponApplied: getIsFreeShippingCouponApplied(state),
    currency: getCurrency(state),
    currencySymbol: BagPageSelectors.getCurrentCurrency(state),
    checkoutStartStatus: getCheckoutMetricsStatus(state, 'checkout_start'),
    freeShippingPromoType: getFreeShippingType(state),
    freeShippingMessageForPromosEnabled: freeShippingMessageForPromos(state),
    isAdyenPaymentEnabled,
    isPayPalDisabled,
    isMixedPaymentWithPaypalValue: isMixedPaymentWithPaypal(state),
    isAdyenApplePayBagPageEnabled: getIsAdyenApplePayBagPageEnabled(state),
    isAdyenApplePayBagPageVisibilityEnabled: getAdyenApplePayBagPageVisibility(state),
    isPayPalSingleStoreBopisEnabled: getPayPalSingleStoreBopisEnabled(state),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(AddedToBagContainer);
